import { Node_Type } from 'ricos-schema';
import { initializeMetadata } from '../converters/nodeUtils.js';
import '../ReadonlyNonEmptyArray-7f84e7de.js';
import '../string-7364f4a2.js';
import 'lodash';
import 'uuid';
import '../utils.js';
import '../converters/generateRandomId.js';

const createEmptyContent = (metadata) => ({
  nodes: [
    {
      type: Node_Type.PARAGRAPH,
      id: "foo",
      nodes: []
    }
  ],
  metadata: initializeMetadata(metadata)
});

export { createEmptyContent };
//# sourceMappingURL=createEmptyContent.js.map
